import { render, staticRenderFns } from "./termsConditions.vue?vue&type=template&id=2bbe94b0&"
import script from "./termsConditions.vue?vue&type=script&lang=js&"
export * from "./termsConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports